export default __webpack_public_path__ + "static/media/ppc_v2.b4e9964b.jpg";